var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"row no-gutters mb-2 text-center"},[_c('div',{staticClass:"col-12"},_vm._l((_vm.frequencySelectOptions),function(option){return _c('b-button',{key:option.value,class:['btn theme-primary mr-2 rounded',
                    {
                      'btn-primary': option.value === _vm.selectedTimePeriod,
                      'btn-secondary': option.value !== _vm.selectedTimePeriod,
                    }
                  ],attrs:{"size":"md"},on:{"click":function($event){return _vm.getAccountPerformance(option.value)}}},[_vm._v("\n        "+_vm._s(option.text)+"\n      ")])}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }